import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { setBadge } from 'modules/common/utils';
import { colors, dimensions } from 'modules/common/styles';
import { companyMenuIcon } from '../../../helpers/dotenv';
import { TiThMenu } from 'react-icons/ti';
import { BsWindowSidebar } from 'react-icons/bs';
import Cookies from 'universal-cookie';

const LeftNavigation = styled.aside`
  width: ${dimensions.headerSpacingWide}px;
  background: ${colors.colorWhite};
  z-index: 6000;
  flex-shrink: 0;
  overflow: visible;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  @media (max-width: 760px)
  {
    background:none;
  }
  // span {
  //   position: absolute;
  //   right: 12px;
  //   top:5;
  //   // bottom: 12px;
  //   // margin-top: -10px;
  //   padding: 4px;
  //   min-width: 19px;
  //   min-height: 19px;
  // }
  > a {
    display: flex;
    margin-top: ${dimensions.unitSpacing}px;
    height: ${dimensions.headerSpacing}px;
    justify-content: center;
    align-items: center;

    img {
      // width: 28px;
      @media (max-width: 760px)
      {
        margin-left: 32px
      }
      
      max-height: 28px;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.1);
      }
    }
  }
`;

const Nav = styled.nav`
  display: block;
  // margin-top: ${dimensions.unitSpacing}px;
  height: calc(100% - 70px);
  // overflow: scroll;
  text-align: center;

  > a {
    display: block;
    height: ${dimensions.headerSpacing + 10}px;
    text-align: center;
    position: relative;
    transition: all 0.3s ease;

    &:hover {
      background-color: #D6EAF8;
    }
    i {
      // opacity: 0.8;
      transition: all 0.3s ease;
    }

    &.active {
      // background: rgba(0, 0, 0, 0.13);

      // &:before {
      //   content: '';
      //   width: 8px;
      //   height:8px;
      //   background: ${colors.colorCoreTeal};
      //   position: absolute;
      //   display: block;
      //   right: 0;
      //   top: 27px;
      //   bottom: 0;
      //   border-radius: 50px;
      // }
      &:before {
        content: '';
        width: 4px;
        height: 90%;
        // background: ${colors.colorCoreTeal};
        background: ${colors.themeBlue};
        position: absolute;
        display: block;
        right: 0;
        // top: 27px;
        bottom: 0;
        border-radius: 20px;
      }

      i {
        opacity: 1;
      }
    }

    &:focus {
      outline: 0;
    }

    &:hover {
      // background: rgba(0, 0, 0, 0.05);

      i {
        opacity: 1;
      }
    }

    @media (max-height: 760px) {
      // height: ${dimensions.headerSpacing}px;

      i {
        line-height: 58px;
      }
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;


const NavIcon = styled.div`
  // font-size: 16px;
  line-height: ${dimensions.headerSpacing-8}px;
  // color: #00000;
  img {
    // width: 28px;
    width: 40px;
  }
`;

const NavText = styled.p`
  font-size: 10px;
  line-height: 11px;
  // color: #808080;
  color: #000;
  // margin-top: -1px;
  font-weight: 600;
`;

const Logo = styled.div`
  img {
    position: fixed;
    margin-top: -22px;
    margin-left: -25px;
  }
`;

const NavbarDropdownContent = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: 100%;
  // margin-top: 18px;
  // margin-left: 22px;
  // background-color: white;
  background-color: #e7f3fb;
  min-width: 160px;
  // padding: 2px 5px;
  color: black;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
  z-index: 99999;
  &:hover {
    // color: black;
    cursor: pointer;
  }
  > a {
    &.active {
    background-color: #D6EAF8;;

    }
  }
`;

const NavbarDropdown = styled.div`
  position: relative;
  display: block;
  // text-align: center;
  color: #808080;
  &:hover {
    background-color: #D6EAF8;
  }
  &:hover ${NavbarDropdownContent} {
    display: block;
  }

  > a {
    &.active {
      // background: rgba(0, 0, 0, 0.13);
      // & {
      //   background-color: #D6EAF8;
      // }
      &:before {
        content: '';
        width: 4px;
        height: 90%;
        // background: ${colors.colorCoreTeal};
        background: ${colors.themeBlue};
        position: absolute;
        display: block;
        right: 0;
        // top: 27px;
        bottom: 0;
        border-radius: 20px;
      }

      i {
        opacity: 1;
      }
    }
  }

`;

const submenuStyle = {
  padding: "12px 15px",
  // marginLeft: "5px",
  textAlign: "left",
  // color: "#808080 !important",
  // backgroundColor: "#808080",
}

const navlinkStyle = {
  color: "#36454F"
  // color:"black"
}

// mobile view

const NavMob = styled.nav`
  display: block;
  width: ${dimensions.headerSpacingWide}px;
  background: ${colors.colorWhite};
  // height: calc(100% - 80px);
  height: 100%;
  z-index: 6000;
  flex-shrink: 0;
  overflow: visible;
  text-align: center;
  padding-top: 40px;
  // position: fixed;
  // left: 0;
  // top: 0;
  // bottom: 0;
  > a {
    display: block;
    margin-top: ${dimensions.unitSpacing}px;
    height: ${dimensions.headerSpacing}px;
    justify-content: center;
    align-items: center;

    img {
      max-height: 28px;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.1);
      }
    }
  } 
`;
const Mobilenavicon = styled.div`
  display: none;
 @media(max-width: 760px)
 {
  height: 100%;
  display: block;

 }
 
  
`;
const Menuicon = styled.div`
 margin-left: 25px;
 margin-top: -43px;
 height: 0%;

`;


class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: '',
      name: '',
      isHover: false,
      navbar: false
    };
  }


  componentDidUpdate() {
    const { __ } = this.context;
    setBadge(this.props.unreadConversationsCount, __('Inbox'));
    // window.addEventListener('resize', this.updateWindowDimensions);
  }
  updateWindowDimensions() {
    if(window.innerWidth <= "760px") {
      this.setState({navbar: true});
    }else{
      this.setState({navbar: false});

    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.unreadConversationsCount > this.props.unreadConversationsCount
    ) {
      // const audio = new Audio('/sound/notify.mp3');
      // audio.play();
    }
  }

  render() {
    // const { unreadConversationsCount } = this.props;
    // const { __, currentUser } = this.context;
    // let agentRole = currentUser.role || '';
    // let isOrgSelected =
    //   global.currentUser && global.currentUser.isOrganizationSelected;
    // const refferOrigin = localStorage.getItem("reffer-origin");
    const basename = process.env.PUBLIC_URL || "/rcs";
    const hostname = process.env.REACT_APP_HOSTNAME;

    const cookie = new Cookies();
    let channelList = localStorage.getItem("productsList") ? Object.keys(JSON.parse(localStorage.getItem("productsList"))) : [];
    let trial_account = cookie.get("userDetails") && cookie.get("userDetails") != "null" ? cookie.get("userDetails").trial_account : "";

    return (<React.Fragment>
      <LeftNavigation>
        {/* {refferOrigin === "" ? 
            <NavLink to="/overview">
              <Logo>
                  <img src={`/images/${companyMenuIcon}`} alt="logo" className='logo' />
                </Logo>
            </NavLink>
          :  */}
          <a href={`${hostname}/home`}>
            <Logo>
              <img src={`${basename}/images/${companyMenuIcon}`} alt="logo" className='logo' />
            </Logo>
          </a>
        {/* } */}
        
            <Mobilenavicon>
            <span>
              <Menuicon>
                <TiThMenu
                  onClick={() => {
                    this.state.navbar ? this.setState({ navbar: false }) : this.setState({ navbar: true })

                    console.log('navbar', this.state.navbar);
                  }}
                  size={20}
                ></TiThMenu>
                  
              </Menuicon>
        </span>
              {this.state.navbar ? 
          //     refferOrigin === "" ? <NavMob>
          //     <NavbarDropdown>
          //       <NavLink to="/overview">
          //         <NavIcon>
          //           <img src="/images/nav/home.png"></img>
          //         </NavIcon>
          //         <NavText>Home</NavText>
          //       </NavLink>
                  
          //   </NavbarDropdown> 
            
            
          //   <hr />
          //   <NavbarDropdown>
          //       <NavLink to="/dashboard">
          //         <NavIcon>
          //           <img src="/images/nav/Dashboard-theme1.png"></img>
          //         </NavIcon>
          //         <NavText>Dashboard</NavText>
          //       </NavLink>
                  
          //   </NavbarDropdown> 
              
          //   <NavbarDropdown>
          //       <NavLink to="/campaign">
          //         <NavIcon>
          //           <img src="/images/nav/message-campaign.png"></img>
          //         </NavIcon>
          //         <NavText>Campaign</NavText>
          //       </NavLink>
                
          //   </NavbarDropdown>  

          //   <NavbarDropdown>
          //       <NavLink to="/analytics">
          //         <NavIcon>
          //           <img src="/images/nav/report-analytics.png"></img>
          //         </NavIcon>
          //         <NavText>Analytics</NavText>
          //       </NavLink>
                
          //   </NavbarDropdown>    
          // </NavMob>

              <NavMob>
                <a href={`${hostname}/home`}>
                  <NavIcon>
                    <img src={`${basename}/images/nav/newTheme/Home.svg`} alt="home"></img>
                  </NavIcon>
                  <NavText>Home</NavText>
                </a>


            <NavbarDropdown>
                <a href={`${hostname}/common-dashboard`}>
                  <NavIcon>
                    <img src="/images/nav/newTheme/Dashboard.svg"></img>
                  </NavIcon>
                  <NavText>Dashboard</NavText>
                </a>
            </NavbarDropdown>

            <NavbarDropdown>
                <a href={
                  trial_account != 2 ? `/upgrade-account` :
                  channelList.includes("voice") ? `${hostname}/voice` : 
                  `${hostname}/home?upgradeChannel=voiceUpgrade`
                  }>
                  <NavIcon>
                    <img src={`${basename}/images/nav/newTheme/Voice.svg`}></img>
                  </NavIcon>
                  <NavText>Voice</NavText>
                </a>
                {/* <NavbarDropdownContent>
                          <a
                            href={`${hostname}:5554/overview`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">

                              Overview
                            </div>
                          </a>
                          <a
                            href={`${hostname}:5554/admin-dashboard`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">

                              Dashboard
                            </div>
                          </a>
                          <a
                            href={`${hostname}:5554/livemonitor`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Live Monitor
                            </div>
                          </a>
                          <a
                            href={`${hostname}:5554/reporting`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Reporting
                            </div>
                          </a>
                        
                          <a
                            href={`${hostname}:5554/team`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Teams
                            </div>
                          </a>
                        
                          <a
                            href={`${hostname}:5554/campaigns`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Campaign
                            </div>
                          </a>
                        
                          <a
                            href={`${hostname}:5554/settings`}
                            style={navlinkStyle}
                          >
                          <div style={submenuStyle} className="submenu">
                          Components
                          </div>
                        </a>
                      </NavbarDropdownContent> */}
              </NavbarDropdown>
 
              
              <NavbarDropdown>
                <a href={
                  trial_account != 2 ? `/upgrade-account` :
                  channelList.includes("sms") ? `${hostname}/sms` : 
                  `${hostname}/home?upgradeChannel=smsUpgrade`
                  }>
                  <NavIcon>
                    <img src={`${basename}/images/nav/newTheme/SMS.svg`} alt="message"></img>
                  </NavIcon>
                  <NavText>Message</NavText>
                </a>
                  {/* <NavbarDropdownContent>
                      <NavLink to="/overview" style={navlinkStyle}>
                        <div style={submenuStyle} className="submenu">
                        Overview
                        </div>
                      </NavLink>
                      <NavLink to="/dashboard" style={navlinkStyle}>
                        <div style={submenuStyle} className="submenu">Dashboard</div>
                      </NavLink>
                      <NavLink to="/campaign" style={navlinkStyle}>
                        <div style={submenuStyle} className="submenu">
                        Campaign</div>
                      </NavLink>
                    
                      <NavLink to="/analytics" style={navlinkStyle}>
                        <div style={submenuStyle} className="submenu">
                        Analytics
                        </div>
                     </NavLink>
                    
                  </NavbarDropdownContent> */}
              </NavbarDropdown>  
            
              
              <NavbarDropdown>
                      <a href={
                        trial_account != 2 ? `/upgrade-account` :
                        channelList.includes("email") ? `${hostname}/email` : 
                        `${hostname}/home?upgradeChannel=emailUpgrade`
                        }>
                        <NavIcon>
                          <img src={`${basename}/images/nav/newTheme/Email.svg`} alt="email"></img>
                        </NavIcon>
                        <NavText>Email</NavText>
                      </a>
                      {/* <NavbarDropdownContent>
                          <a
                            href={`${hostname}:5557/whatsapp/overview`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Overview
                            </div>
                          </a>
                          <a
                            href={`${hostname}:5557/whatsapp/dashboard`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Dashboard
                            </div>
                          </a>
                          <a
                            href={`${hostname}:5557/whatsapp/campaign`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Campaign
                            </div>
                          </a>

                          <a
                            href={`${hostname}:5557/whatsapp/analytics`}
                            style={navlinkStyle}
                          >                        
                            <div style={submenuStyle} className="submenu">
                              Analytics
                            </div>
                          </a>

                      </NavbarDropdownContent> */}
                    </NavbarDropdown>

                    <NavbarDropdown>
                  <a className='active'>
                    <NavIcon>
                      <img src={`${basename}/images/nav/newTheme/A2P.svg`}></img>
                    </NavIcon>
                    <NavText>A2P+</NavText>
                  </a>
                  <NavbarDropdownContent>
                      <a href={
                        trial_account != 2 ? `/upgrade-account` :
                        channelList.includes("whatsapp") ? `${hostname}/whatsapp` : 
                        `${hostname}/home?upgradeChannel=whatsappUpgrade`
                        } style={navlinkStyle}>
                        <div style={submenuStyle} className="submenu">
                        WhatsApp
                        </div>
                      </a>
                      <a href={
                        trial_account != 2 ? `/upgrade-account` :
                        channelList.includes("rcs") ? `${hostname}/rcs` : 
                        `${hostname}/home?upgradeChannel=rcsUpgrade`
                        } style={navlinkStyle}>
                        <div style={submenuStyle} className="submenu">
                          RCS
                        </div>
                      </a>
                  </NavbarDropdownContent>
              </NavbarDropdown>
                    <NavbarDropdown>
                      <a href={`${hostname}/cpaas-api`}>
                        <NavIcon>
                          <img src={`${basename}/images/nav/newTheme/API.svg`} alt="cpass"></img>
                        </NavIcon>
                        <NavText>CPaaS</NavText>
                      </a>
                      {/* <NavbarDropdownContent>
                          <a
                            href={`${hostname}:5559/cpass-api/overview`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Overview
                            </div>
                          </a>
                          <a
                            href={`${hostname}:5559/cpass-api/get-started/sms-api/`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">SMS API</div>
                          </a>
                          <a
                            href={`${hostname}:5559/cpass-api/get-started/whatsapp-api`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">WhatsApp Business API</div>
                          </a>
                          <a
                            href={`${hostname}:5559/cpass-api/get-started/voice-api`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">Voice API</div>
                          </a>
                          <a
                            href={`${hostname}:5559/cpass-api/get-started/rcs-api`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">RCS API</div>
                            
                          </a>
                          <a
                            href={`${hostname}:5559/cpass-api/crm-integration`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">CRM Intergration</div>
                          </a>
                      </NavbarDropdownContent> */}
                    </NavbarDropdown>    
              
            <NavbarDropdown>
                <a href={`${hostname}/global-reports`} activeClassName="active">
                  <NavIcon>
                    <img src="/images/nav/newTheme/Analytics.svg"></img>
                  </NavIcon>
                  <NavText>Analytics</NavText>
                </a>
            </NavbarDropdown>
            <NavbarDropdown>
                <a href={trial_account != 2 ? `/upgrade-account` : `${hostname}/template`} activeClassName="active">
                  <NavIcon>
                    <img src="/images/nav/newTheme/Template.svg"></img>
                  </NavIcon>
                  <NavText>Template</NavText>
                </a>
            </NavbarDropdown>
              <a href={`${hostname}/settings`}>
                <NavIcon>
                  <img src={`${basename}/images/nav/newTheme/Setting.svg`}></img>
                </NavIcon>
                <NavText>Settings</NavText>
              </a>
            
          </NavMob> : 
           ""
           }

            </Mobilenavicon> 
        
            {/* <a href="http://103.209.99.11:4545/home">
          <Logo>
            <img src={`/images/${companyMenuIcon}`} alt="logo" className='logo' />
          </Logo>
         
        </a> */}
          
        {/* <Mobilenavicon>
            <Menuicon>
            <TiThMenu
              onClick={() => {
                this.state.navbar ? this.setState({ navbar: false }) : this.setState({ navbar: true })

                console.log('navbar', this.state.navbar);
              }}
            ></TiThMenu>
            </Menuicon>
            {this.state.navbar ? <React.Fragment>

            </React.Fragment>: ""}
        </Mobilenavicon> */}
        {/* {global.currentUser &&
            global.currentUser.allowAccess &&
            global.currentUser.allowAccess.indexOf('INBOX') !== -1 && (
              <Tip placement="right" text={__('Inbox')}>
                <NavLink to="/inbox" activeClassName="active">
                  <NavIcon>
                    <img src="/images/chat.png"></img>
                  </NavIcon>
                  {unreadConversationsCount !== 0 && (
                    <Label shake lblStyle="danger" ignoreTrans>
                      {unreadConversationsCount}
                    </Label>
                  )}
                </NavLink>
              </Tip>
            )} */}
            
          {/* desktop view */}

          {/* Checking whether user is logged in & redirecting from cpass or SMS*/}

          <Nav>
          <a href={`${hostname}/home`}>
                  <NavIcon>
                    <img src={`${basename}/images/nav/newTheme/Home.svg`} alt="home"></img>
                  </NavIcon>
                  <NavText>Home</NavText>
                </a>

            <NavbarDropdown>
                <a href={`${hostname}/common-dashboard`}>
                  <NavIcon>
                    <img src="/images/nav/newTheme/Dashboard.svg"></img>
                  </NavIcon>
                  <NavText>Dashboard</NavText>
                </a>
            </NavbarDropdown>

            <NavbarDropdown>
                <a href={
                  trial_account != 2 ? `/upgrade-account` :
                  channelList.includes("voice") ? `${hostname}/voice` : 
                  `${hostname}/home?upgradeChannel=voiceUpgrade`
                  }>
                  <NavIcon>
                    <img src={`${basename}/images/nav/newTheme/Voice.svg`}></img>
                  </NavIcon>
                  <NavText>Voice</NavText>
                </a>
                {/* <NavbarDropdownContent>
                          <a
                            href={`${hostname}:5554/overview`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">

                              Overview
                            </div>
                          </a>
                          <a
                            href={`${hostname}:5554/admin-dashboard`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">

                              Dashboard
                            </div>
                          </a>
                          <a
                            href={`${hostname}:5554/livemonitor`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Live Monitor
                            </div>
                          </a>
                          <a
                            href={`${hostname}:5554/reporting`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Reporting
                            </div>
                          </a>
                        
                          <a
                            href={`${hostname}:5554/team`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Teams
                            </div>
                          </a>
                        
                          <a
                            href={`${hostname}:5554/campaigns`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Campaign
                            </div>
                          </a>
                        
                          <a
                            href={`${hostname}:5554/settings`}
                            style={navlinkStyle}
                          >
                          <div style={submenuStyle} className="submenu">
                          Components
                          </div>
                        </a>
                      </NavbarDropdownContent> */}
              </NavbarDropdown>
 
              
              <NavbarDropdown>
                <a href={
                  trial_account != 2 ? `/upgrade-account` :
                  channelList.includes("sms") ? `${hostname}/sms` : 
                  `${hostname}/home?upgradeChannel=smsUpgrade`
                  }>
                  <NavIcon>
                    <img src={`${basename}/images/nav/newTheme/SMS.svg`} alt="message"></img>
                  </NavIcon>
                  <NavText>Message</NavText>
                </a>
                  {/* <NavbarDropdownContent>
                      <NavLink to="/overview" style={navlinkStyle}>
                        <div style={submenuStyle} className="submenu">
                        Overview
                        </div>
                      </NavLink>
                      <NavLink to="/dashboard" style={navlinkStyle}>
                        <div style={submenuStyle} className="submenu">Dashboard</div>
                      </NavLink>
                      <NavLink to="/campaign" style={navlinkStyle}>
                        <div style={submenuStyle} className="submenu">
                        Campaign</div>
                      </NavLink>
                    
                      <NavLink to="/analytics" style={navlinkStyle}>
                        <div style={submenuStyle} className="submenu">
                        Analytics
                        </div>
                     </NavLink>
                    
                  </NavbarDropdownContent> */}
              </NavbarDropdown>  
            
              
              <NavbarDropdown>
                      <a href={
                        trial_account != 2 ? `/upgrade-account` :
                        channelList.includes("email") ? `${hostname}/email` : 
                        `${hostname}/home?upgradeChannel=emailUpgrade`
                        }>
                        <NavIcon>
                          <img src={`${basename}/images/nav/newTheme/Email.svg`} alt="email"></img>
                        </NavIcon>
                        <NavText>Email</NavText>
                      </a>
                      {/* <NavbarDropdownContent>
                          <a
                            href={`${hostname}:5557/whatsapp/overview`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Overview
                            </div>
                          </a>
                          <a
                            href={`${hostname}:5557/whatsapp/dashboard`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Dashboard
                            </div>
                          </a>
                          <a
                            href={`${hostname}:5557/whatsapp/campaign`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Campaign
                            </div>
                          </a>

                          <a
                            href={`${hostname}:5557/whatsapp/analytics`}
                            style={navlinkStyle}
                          >                        
                            <div style={submenuStyle} className="submenu">
                              Analytics
                            </div>
                          </a>

                      </NavbarDropdownContent> */}
                    </NavbarDropdown>

                    <NavbarDropdown>
                  <a className='active'>
                    <NavIcon>
                      <img src={`${basename}/images/nav/newTheme/A2P.svg`}></img>
                    </NavIcon>
                    <NavText>A2P+</NavText>
                  </a>
                  <NavbarDropdownContent>
                      <a href={
                        trial_account != 2 ? `/upgrade-account` :
                        channelList.includes("whatsapp") ? `${hostname}/whatsapp` : 
                        `${hostname}/home?upgradeChannel=whatsappUpgrade`
                        } style={navlinkStyle}>
                        <div style={submenuStyle} className="submenu">
                        WhatsApp
                        </div>
                      </a>
                      <a href={
                        trial_account != 2 ? `/upgrade-account` :
                        channelList.includes("rcs") ? `${hostname}/rcs` : 
                        `${hostname}/home?upgradeChannel=rcsUpgrade`
                        } style={navlinkStyle}>
                        <div style={submenuStyle} className="submenu">
                          RCS
                        </div>
                      </a>
                  </NavbarDropdownContent>
              </NavbarDropdown>
                    <NavbarDropdown>
                      <a href={`${hostname}/cpaas-api`}>
                        <NavIcon>
                          <img src={`${basename}/images/nav/newTheme/API.svg`} alt="cpass"></img>
                        </NavIcon>
                        <NavText>CPaaS</NavText>
                      </a>
                      {/* <NavbarDropdownContent>
                          <a
                            href={`${hostname}:5559/cpass-api/overview`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">
                            Overview
                            </div>
                          </a>
                          <a
                            href={`${hostname}:5559/cpass-api/get-started/sms-api/`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">SMS API</div>
                          </a>
                          <a
                            href={`${hostname}:5559/cpass-api/get-started/whatsapp-api`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">WhatsApp Business API</div>
                          </a>
                          <a
                            href={`${hostname}:5559/cpass-api/get-started/voice-api`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">Voice API</div>
                          </a>
                          <a
                            href={`${hostname}:5559/cpass-api/get-started/rcs-api`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">RCS API</div>
                            
                          </a>
                          <a
                            href={`${hostname}:5559/cpass-api/crm-integration`}
                            style={navlinkStyle}
                          >
                            <div style={submenuStyle} className="submenu">CRM Intergration</div>
                          </a>
                      </NavbarDropdownContent> */}
                    </NavbarDropdown>    
              
            <NavbarDropdown>
                <a href={`${hostname}/global-reports`} activeClassName="active">
                  <NavIcon>
                    <img src="/images/nav/newTheme/Analytics.svg"></img>
                  </NavIcon>
                  <NavText>Analytics</NavText>
                </a>
            </NavbarDropdown>
            <NavbarDropdown>
                <a href={trial_account != 2 ? `/upgrade-account` : `${hostname}/template`} activeClassName="active">
                  <NavIcon>
                    <img src="/images/nav/newTheme/Template.svg"></img>
                  </NavIcon>
                  <NavText>Template</NavText>
                </a>
            </NavbarDropdown>
              <a href={`${hostname}/settings`}>
                <NavIcon>
                  <img src={`${basename}/images/nav/newTheme/Setting.svg`}></img>
                </NavIcon>
                <NavText>Settings</NavText>
              </a>    
          </Nav>
        
      </LeftNavigation>
      </React.Fragment>
    ) 
  }
}

Navigation.propTypes = {
  unreadConversationsCount: PropTypes.number
};

Navigation.contextTypes = {
  __: PropTypes.func,
  currentUser: PropTypes.object
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/modules/layout/components/Navigation.js